import { defineMessages } from 'react-intl';

export const fieldDescriptionMessages = defineMessages({
  // Order
  orderNumber: {
    id: '/DewTr',
    defaultMessage: 'Unique identifier for the order',
    description: 'Field description for order number',
  },
  orderId: {
    id: 'VOFK+J',
    defaultMessage: 'Internal order ID number',
    description: 'Field description for order ID',
  },
  orderDate: {
    id: 'SS9icQ',
    defaultMessage: 'Date the order was placed',
    description: 'Field description for order date',
  },
  orderTotal: {
    id: 'fsIjxs',
    defaultMessage: 'Total amount for the order',
    description: 'Field description for order total',
  },
  orderTotalMarketplace: {
    id: '2BNI5V',
    defaultMessage: 'Order total in marketplace currency',
    description: 'Field description for order total in marketplace currency',
  },
  orderTotalQuantityWithoutZeroDollar: {
    id: 'jPvZpf',
    defaultMessage: 'Order quantity excluding free items',
    description: 'Field description for order total quantity without zero dollar items',
  },
  shipDate: {
    id: 'UIqsls',
    defaultMessage: 'Date the order was shipped',
    description: 'Field description for ship date',
  },
  shipByDate: {
    id: 'KhdVHX',
    defaultMessage: 'Required ship-by deadline',
    description: 'Field description for ship by date',
  },
  paymentDate: {
    id: '18iPZM',
    defaultMessage: 'Date payment was received',
    description: 'Field description for payment date',
  },
  payDate: {
    id: 'KaFFRG',
    defaultMessage: 'Date payment was processed',
    description: 'Field description for pay date',
  },
  currentDate: {
    id: 'R/oXdI',
    defaultMessage: "Today's date",
    description: 'Field description for current date',
  },
  importKey: {
    id: 'YrW8g6',
    defaultMessage: 'External import reference key',
    description: 'Field description for import key',
  },
  barcode: {
    id: 'Zr6MzZ',
    defaultMessage: 'Scannable barcode for the order',
    description: 'Field description for barcode',
  },
  returnUrl: {
    id: 'wb0mtF',
    defaultMessage: 'URL for customer return requests',
    description: 'Field description for return URL',
  },

  // Shipping
  active: {
    id: 'lfuhe/',
    defaultMessage: 'Whether shipment is active',
    description: 'Field description for active shipment status',
  },
  carrierName: {
    id: 'ZveM1I',
    defaultMessage: 'Shipping carrier for delivery',
    description: 'Field description for carrier name',
  },
  shippingService: {
    id: 'Q/KbF+',
    defaultMessage: 'Selected shipping service level',
    description: 'Field description for shipping service',
  },
  requestedShippingService: {
    id: 'K1/QeL',
    defaultMessage: "Buyer's requested shipping method",
    description: 'Field description for requested shipping service',
  },
  trackingNumber: {
    id: 'nzbh0A',
    defaultMessage: 'Shipment tracking number',
    description: 'Field description for tracking number',
  },
  trackingUrl: {
    id: 'cH/L+b',
    defaultMessage: 'Link to track the shipment',
    description: 'Field description for tracking URL',
  },
  packageType: {
    id: 'axtmwV',
    defaultMessage: 'Type of shipping package',
    description: 'Field description for package type',
  },
  dimensions: {
    id: 'H/pp3u',
    defaultMessage: 'Package dimensions (L×W×H)',
    description: 'Field description for dimensions',
  },
  weight: {
    id: 'R5v0zR',
    defaultMessage: 'Package weight',
    description: 'Field description for weight',
  },
  uspsZone: {
    id: 'ZN+Ggj',
    defaultMessage: 'USPS shipping zone number',
    description: 'Field description for USPS zone',
  },

  // Recipient
  recipientName: {
    id: 'wCsdz5',
    defaultMessage: 'Full name of the recipient',
    description: 'Field description for recipient name',
  },
  recipientEmail: {
    id: 'xgPERN',
    defaultMessage: "Recipient's email address",
    description: 'Field description for recipient email',
  },
  recipientPhone: {
    id: 'j+cEiX',
    defaultMessage: "Recipient's phone number",
    description: 'Field description for recipient phone',
  },
  recipientCompany: {
    id: 'C6OBbQ',
    defaultMessage: "Recipient's company name",
    description: 'Field description for recipient company',
  },
  recipientAddress: {
    id: 'AY62Py',
    defaultMessage: 'Full recipient shipping address',
    description: 'Field description for recipient address',
  },
  recipientAddressFullCountry: {
    id: '0WORmN',
    defaultMessage: 'Recipient address with full country',
    description: 'Field description for recipient address with full country name',
  },
  recipientNameAndCompany: {
    id: '3Cl+7t',
    defaultMessage: 'Recipient name and company combined',
    description: 'Field description for recipient name and company',
  },

  // Buyer
  buyerName: {
    id: 'sVBYID',
    defaultMessage: 'Name of the buyer',
    description: 'Field description for buyer name',
  },
  notesFromBuyer: {
    id: '/bl6KB',
    defaultMessage: 'Notes left by the buyer',
    description: 'Field description for notes from buyer',
  },
  notesToBuyer: {
    id: '9X1jYV',
    defaultMessage: 'Seller notes sent to buyer',
    description: 'Field description for notes to buyer',
  },
  giftMessage: {
    id: 'D4Xw8Q',
    defaultMessage: 'Gift message from the buyer',
    description: 'Field description for gift message',
  },
  internalNotes: {
    id: 'NZ0omE',
    defaultMessage: 'Internal notes about the order',
    description: 'Field description for internal notes',
  },
  username: {
    id: '0CCXRl',
    defaultMessage: "Buyer's marketplace username",
    description: 'Field description for username',
  },

  // Store
  storeName: {
    id: 'N55GmK',
    defaultMessage: 'Name of the selling store',
    description: 'Field description for store name',
  },
  storeCompanyName: {
    id: 'Y3ndWa',
    defaultMessage: "Store's company name",
    description: 'Field description for store company name',
  },
  companyName: {
    id: '3mlrxJ',
    defaultMessage: "Store's company name",
    description: 'Field description for company name',
  },
  storeEmail: {
    id: '1ztLq1',
    defaultMessage: 'Store contact email address',
    description: 'Field description for store email',
  },
  email: {
    id: 'Bt+f2H',
    defaultMessage: 'Store contact email address',
    description: 'Field description for email',
  },
  storePhone: {
    id: 'iEevBl',
    defaultMessage: 'Store contact phone number',
    description: 'Field description for store phone',
  },
  phone: {
    id: 'X4hK6k',
    defaultMessage: 'Store contact phone number',
    description: 'Field description for phone',
  },
  storeWebsite: {
    id: '39N0Jm',
    defaultMessage: 'Store website URL',
    description: 'Field description for store website',
  },
  website: {
    id: 'FqTOQq',
    defaultMessage: 'Store website URL',
    description: 'Field description for website',
  },
  storeLogo: {
    id: '/RYNi5',
    defaultMessage: 'Store logo image',
    description: 'Field description for store logo',
  },
  logoUrl: {
    id: 'HODytQ',
    defaultMessage: 'Store logo image URL',
    description: 'Field description for logo URL',
  },

  // Warehouse
  storeLocation: {
    id: 'f+OU1i',
    defaultMessage: 'Warehouse location details',
    description: 'Field description for store location',
  },
  warehouseLocation: {
    id: 'WJSlk5',
    defaultMessage: 'Warehouse location details',
    description: 'Field description for warehouse location',
  },
  warehouseAddress: {
    id: 'yJiUvX',
    defaultMessage: 'Warehouse street address',
    description: 'Field description for warehouse address',
  },
  warehouseCompany: {
    id: 'OCRXNw',
    defaultMessage: 'Warehouse company name',
    description: 'Field description for warehouse company',
  },
  warehouseCountry: {
    id: '5naQtJ',
    defaultMessage: 'Warehouse country',
    description: 'Field description for warehouse country',
  },
  warehouseName: {
    id: 'r60AfC',
    defaultMessage: 'Name of the warehouse',
    description: 'Field description for warehouse name',
  },
  name: {
    id: 'VQo5Uw',
    defaultMessage: 'Warehouse name',
    description: 'Field description for name',
  },
  company: {
    id: 'yHXdlX',
    defaultMessage: 'Warehouse company name',
    description: 'Field description for company',
  },
  street1: {
    id: 'Pl16rQ',
    defaultMessage: 'Warehouse address line 1',
    description: 'Field description for street 1',
  },
  street2: {
    id: 'i9yVjM',
    defaultMessage: 'Warehouse address line 2',
    description: 'Field description for street 2',
  },
  street3: {
    id: '2zuhWN',
    defaultMessage: 'Warehouse address line 3',
    description: 'Field description for street 3',
  },
  state: {
    id: '6lD4tn',
    defaultMessage: 'Warehouse state or province',
    description: 'Field description for state',
  },
  postalCode: {
    id: 'uyOYBO',
    defaultMessage: 'Warehouse postal/ZIP code',
    description: 'Field description for postal code',
  },
  country: {
    id: 'jDZ386',
    defaultMessage: 'Warehouse country code',
    description: 'Field description for country',
  },
  countryName: {
    id: 'nRqGuw',
    defaultMessage: 'Warehouse full country name',
    description: 'Field description for country name',
  },

  // Billing
  street: {
    id: '5w+cFj',
    defaultMessage: 'Billing street address',
    description: 'Field description for street',
  },
  city: {
    id: 'kkBQ99',
    defaultMessage: 'Billing city name',
    description: 'Field description for city',
  },
  billingStreet: {
    id: 'k5+bE/',
    defaultMessage: 'Billing street address',
    description: 'Field description for billing street',
  },
  billingCity: {
    id: '6RuPCs',
    defaultMessage: 'Billing city name',
    description: 'Field description for billing city',
  },

  // Financial
  amountPaid: {
    id: 'VrSoiA',
    defaultMessage: 'Total amount paid by buyer',
    description: 'Field description for amount paid',
  },
  shippingPaid: {
    id: 'eaiB79',
    defaultMessage: 'Shipping amount paid by buyer',
    description: 'Field description for shipping paid',
  },
  taxPaid: {
    id: 'iHUZYj',
    defaultMessage: 'Tax amount paid',
    description: 'Field description for tax paid',
  },
  carrierFee: {
    id: 'SEbDXa',
    defaultMessage: 'Carrier shipping fee charged',
    description: 'Field description for carrier fee',
  },
  adjustment: {
    id: 'LlqIZT',
    defaultMessage: 'Order price adjustment amount',
    description: 'Field description for adjustment',
  },

  // Custom fields
  customField1: {
    id: 'Sj8fgm',
    defaultMessage: 'Custom field 1 value',
    description: 'Field description for custom field 1',
  },
  customField2: {
    id: 'yvTtRI',
    defaultMessage: 'Custom field 2 value',
    description: 'Field description for custom field 2',
  },
  customField3: {
    id: '1THzrI',
    defaultMessage: 'Custom field 3 value',
    description: 'Field description for custom field 3',
  },

  // Item / Product
  sku: {
    id: 'EoKwFj',
    defaultMessage: 'Product stock keeping unit code',
    description: 'Field description for SKU',
  },
  productSku: {
    id: '91im4B',
    defaultMessage: 'Product SKU identifier',
    description: 'Field description for product SKU',
  },
  itemSku: {
    id: 'tqFln+',
    defaultMessage: 'Item SKU identifier',
    description: 'Field description for item SKU',
  },
  fillSku: {
    id: 'hWpq91',
    defaultMessage: 'SKU used for fulfillment',
    description: 'Field description for fill SKU',
  },
  quantity: {
    id: 'LiUwBk',
    defaultMessage: 'Number of units ordered',
    description: 'Field description for quantity',
  },
  itemQuantity: {
    id: '8TSXTp',
    defaultMessage: 'Number of units for this item',
    description: 'Field description for item quantity',
  },
  productName: {
    id: 'LBk2RI',
    defaultMessage: 'Name of the product',
    description: 'Field description for product name',
  },
  productDescription: {
    id: '7Cu+p2',
    defaultMessage: 'Product description text',
    description: 'Field description for product description',
  },
  productLocation: {
    id: 'CwdUXi',
    defaultMessage: 'Warehouse bin location for product',
    description: 'Field description for product location',
  },
  title: {
    id: 'ooCsX2',
    defaultMessage: 'Product title',
    description: 'Field description for title',
  },
  itemTitle: {
    id: '4eR3kD',
    defaultMessage: 'Line item title',
    description: 'Field description for item title',
  },
  options: {
    id: '4AePhs',
    defaultMessage: 'Selected product options/variants',
    description: 'Field description for options',
  },
  itemOptions: {
    id: 'v2oIG2',
    defaultMessage: 'Selected product options/variants',
    description: 'Field description for item options',
  },
  imageUrl: {
    id: 'Wm1L8b',
    defaultMessage: 'Product image URL',
    description: 'Field description for image URL',
  },
  unitPrice: {
    id: 'OTTmET',
    defaultMessage: 'Price per single unit',
    description: 'Field description for unit price',
  },
  extendedPrice: {
    id: 'TEt/3k',
    defaultMessage: 'Total price for line item',
    description: 'Field description for extended price',
  },
  extendedPriceZero: {
    id: 'EUmVdo',
    defaultMessage: 'Extended price including zero values',
    description: 'Field description for extended price zero',
  },
  isZeroPrice: {
    id: 'nlIA4h',
    defaultMessage: 'Whether item has zero price',
    description: 'Field description for is zero price',
  },
  isAdjustment: {
    id: 'Bc0KYK',
    defaultMessage: 'Whether item is an adjustment',
    description: 'Field description for is adjustment',
  },
  location: {
    id: 'XT85Pp',
    defaultMessage: 'Inventory bin location',
    description: 'Field description for location',
  },
  allocated: {
    id: 'MqjmDr',
    defaultMessage: 'Whether inventory is allocated',
    description: 'Field description for allocated',
  },
  ASIN: {
    id: 'FDNc2b',
    defaultMessage: 'Amazon Standard Identification Number',
    description: 'Field description for ASIN',
  },
  asin: {
    id: 'GpZOMB',
    defaultMessage: 'Amazon Standard Identification Number',
    description: 'Field description for asin (lowercase)',
  },
  UPC: {
    id: 'd/hiTB',
    defaultMessage: 'Universal Product Code barcode',
    description: 'Field description for UPC',
  },
  upc: {
    id: '+1O8XU',
    defaultMessage: 'Universal Product Code barcode',
    description: 'Field description for upc (lowercase)',
  },
  marketplaceItemNumber: {
    id: 'hZpMC/',
    defaultMessage: 'Marketplace-specific item identifier',
    description: 'Field description for marketplace item number',
  },

  // Item lists
  itemList: {
    id: 'hQyYOe',
    defaultMessage: 'Standard item list table',
    description: 'Field description for item list',
  },
  itemListNoSKU: {
    id: 'hEFTE7',
    defaultMessage: 'Item list without SKU column',
    description: 'Field description for item list without SKU',
  },
  itemListShowCost: {
    id: 'dKt6sQ',
    defaultMessage: 'Item list with cost column',
    description: 'Field description for item list with cost',
  },
  itemListShowOptions: {
    id: 'feGea1',
    defaultMessage: 'Item list with options column',
    description: 'Field description for item list with options',
  },
  itemListImages: {
    id: 'q6NWrJ',
    defaultMessage: 'Item list with product images',
    description: 'Field description for item list with images',
  },
  itemListExternalId: {
    id: '6C2yvo',
    defaultMessage: 'Item list with external IDs',
    description: 'Field description for item list with external IDs',
  },
  itemListHideZero: {
    id: 'gLFrTA',
    defaultMessage: 'Item list hiding zero-dollar items',
    description: 'Field description for item list hiding zero-dollar items',
  },

  // Totals
  totalQuantity: {
    id: 'Wk7j75',
    defaultMessage: 'Total number of items ordered',
    description: 'Field description for total quantity',
  },
  totalQuantityWithoutAdjustments: {
    id: 'MnuIZc',
    defaultMessage: 'Total quantity excluding adjustments',
    description: 'Field description for total quantity without adjustments',
  },
  totalQuantityWithoutAdjustmentsandZeroDollarItems: {
    id: 'A6esM/',
    defaultMessage: 'Total excluding adjustments and free items',
    description: 'Field description for total quantity without adjustments and zero dollar items',
  },
  totalQuantityWithoutZeroDollarItem: {
    id: 'XSqugB',
    defaultMessage: 'Total excluding zero-dollar items',
    description: 'Field description for total quantity without zero dollar items',
  },
  itemsTotal: {
    id: '2Ru2My',
    defaultMessage: 'Sum of all item prices',
    description: 'Field description for items total',
  },

  // Settings
  showLogo: {
    id: '53C1DN',
    defaultMessage: 'Display store logo on slip',
    description: 'Field description for show logo setting',
  },
  showPrices: {
    id: 'SYAeoS',
    defaultMessage: 'Display item prices on slip',
    description: 'Field description for show prices setting',
  },
  showSkus: {
    id: 'XtNhwb',
    defaultMessage: 'Display SKUs on slip',
    description: 'Field description for show SKUs setting',
  },
  showBarcode: {
    id: 'Kv3ALy',
    defaultMessage: 'Display barcode on slip',
    description: 'Field description for show barcode setting',
  },
  showItemLocations: {
    id: 'bpDvRK',
    defaultMessage: 'Display item warehouse locations',
    description: 'Field description for show item locations setting',
  },
  showDiscounts: {
    id: 'RFQ0Hf',
    defaultMessage: 'Display discount amounts on slip',
    description: 'Field description for show discounts setting',
  },
  hideZeroQuantityItems: {
    id: 'fE2NoL',
    defaultMessage: 'Hide items with zero quantity',
    description: 'Field description for hide zero quantity items setting',
  },
  showReturnQrCode: {
    id: 'ZR7wy7',
    defaultMessage: 'Display QR code for returns',
    description: 'Field description for show return QR code setting',
  },

  // Other
  packingSlipMessage: {
    id: 'FsLc+R',
    defaultMessage: 'Custom packing slip message',
    description: 'Field description for packing slip message',
  },
  scanOrderNumber: {
    id: 'MgpU6z',
    defaultMessage: 'Scannable order number barcode',
    description: 'Field description for scan order number',
  },
  linebreak: {
    id: 'GsDUC1',
    defaultMessage: 'Line break in template',
    description: 'Field description for linebreak',
  },
});
